<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>

         <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Desde dónde se emiten los documentos. 
                Ej.: tienda, caja, terminal. Define serie,
                numeración y estado. Úsalo para decir desde
                qué punto se generan cotizaciones, pedidos
                o facturas.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Punto de Emisión
          </h2>        
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Configura los <b>puntos de emisión</b> de donde se emitirá los documentos.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Punto de Emisión</div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          <!-- Show filters button -->
          <!-- <button
              mat-icon-button
              color="primary"
              (click)="sidenav.toggle()"
              matTooltip="Mostrar filtros"
            >
              <mat-icon svgIcon="filter_list"></mat-icon>
            </button> -->
          <!-- Add button (only icon) -->
          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort [trackBy]="trackByFn">
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                <td mat-cell *matCellDef="let visit" class="text-sm uppercase">{{ visit.name }}</td>
              </ng-container>

              <ng-container matColumnDef="subroute">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ruta</th>
                <td mat-cell *matCellDef="let visit" class="text-sm uppercase leading-tight">
                  <div *ngIf="visit.subRoute?.externalKeys?.code">
                    <b style="font-size: 10px;">{{ visit.subRoute?.externalKeys?.code }}</b>
                  </div>
                  {{ visit?.subRoute?.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="sales">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Oficina de venta</th>
                <td mat-cell *matCellDef="let visit" class="text-sm uppercase leading-tight">
                  <div *ngIf="visit?.salesOffices[0]?.externalKeys?.code">
                    <b style="font-size: 10px;">{{ visit?.salesOffices[0]?.externalKeys?.code }}</b>
                  </div>
                  {{ visit?.salesOffices[0]?.name }}
                </td>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                <td mat-cell *matCellDef="let visit" class="px-6 text-left">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="visit.statusId == 1"
                    [(ngModel)]="visit.statusId" [color]="'success'" (ngModelChange)="onStatusChange($event, visit)">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let visit" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openRangePage(visit)">
                      <mat-icon svgIcon="heroicons_outline:link"></mat-icon>
                      <span>Ir a Rangos</span>
                    </button>
                    <button mat-menu-item (click)="openEditModal(visit)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(visit)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentCreateEmissionPoint.name" name="name" required>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="currentCreateEmissionPoint.type" (selectionChange)="changeTypeCreate($event)"
              name="type" required>
              @for (type of typeList; track type) {
              <mat-option [value]="type">
                {{ getListTypeLabel(type) }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if(currentCreateEmissionPoint.type !== undefined && currentCreateEmissionPoint.type !== null){
          <div class="col-span-2">
            <label>Compañía</label>
            <ng-select [(ngModel)]="currentCreateEmissionPoint.companyId" [items]="companyList" bindLabel="name"
              bindValue="_id" [searchable]="true" placeholder="Seleccione una compañía" name="companyId"
              (ngModelChange)="onCompanySelectionChange($event)" [compareWith]="compareById" [appendTo]="'body'"
              required>
            </ng-select>
          </div>
          }

          @if (currentCreateEmissionPoint.type !== undefined && currentCreateEmissionPoint.type !== null
          && currentCreateEmissionPoint.type == sourceToSetSerialEnum.SALES_OFFICE) {
          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label for="group-select">Oficina de venta</mat-label>
            <mat-select [formControl]="salesOfficeMultiCtrl" placeholder="Seleccione las oficinas de venta"
              [multiple]="true" [disabled]="isSalesOfficeDisabled"
              required><!-- (selectionChange)="onSalesOfficeSelectionChange($event)"-->
              <mat-option>
                <ngx-mat-select-search [showToggleAllCheckbox]="true" [toggleAllCheckboxIndeterminate]="isIndeterminate"
                  [toggleAllCheckboxChecked]="isChecked" (toggleAll)="toggleSelectAll($event)"
                  [formControl]="salesOfficeMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
                  [clearSearchLabel]="'Limpiar búsqueda'"
                  [placeholderLabel]="'Buscar oficina de venta...'"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let sales of filteredSalesOffice | async" [value]="sales">
                <b>{{sales.externalKeys?.code}}</b>-{{ sales.name }}
              </mat-option>
            </mat-select>
            <!-- Mensaje de error si no se ha seleccionado ningún valor -->
            <mat-error *ngIf="
                  salesOfficeMultiCtrl.hasError('required') &&
                  (salesOfficeMultiCtrl.dirty || salesOfficeMultiCtrl.touched)
                ">
              Seleccione oficina de venta
            </mat-error>
          </mat-form-field>
          }

          @if(currentCreateEmissionPoint.type && currentCreateEmissionPoint.type == sourceToSetSerialEnum.SUB_ROUTE ){
          <div class="col-span-2">
            <label>Ruta</label>
            <ng-select [(ngModel)]="currentCreateEmissionPoint.subRouteId" [items]="subRouteListWithCodeName" bindLabel="codeWithName"
              bindValue="_id" [searchable]="true" placeholder="Seleccione una ruta" name="subRouteId"
              (ngModelChange)="onSubRouteSelectionChange($event)" [appendTo]="'body'" [disabled]="isSubRouteDisabled"
              required>
            </ng-select>
          </div>
          }
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createEmissionPoint()"
          [disabled]="!createForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #editForm="ngForm" class="grid grid-cols-2 gap-4">
          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentUpdateEmissionPoint.name" name="name" required>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="currentUpdateEmissionPoint.type" name="type"
              (selectionChange)="changeTypeUpdate($event)" required>
              @for (type of typeList; track type) {
              <mat-option [value]="type">
                {{ getListTypeLabel(type) }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if(currentUpdateEmissionPoint.type !== undefined && currentUpdateEmissionPoint.type !== null){
          <div class="col-span-2">
            <label>Compañía</label>
            <ng-select [(ngModel)]="currentUpdateEmissionPoint.company" [items]="companyList" bindLabel="name"
              bindValue="_id" [searchable]="true" placeholder="Seleccione una compañía" name="companyId"
              (ngModelChange)="onCompanySelectionChange($event)" [compareWith]="compareById" [appendTo]="'body'"
              required>
            </ng-select>
          </div>
          }

          @if (currentUpdateEmissionPoint.type !== undefined && currentUpdateEmissionPoint.type !== null
          && currentUpdateEmissionPoint.type == sourceToSetSerialEnum.SALES_OFFICE) {
          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label for="group-select">Oficina de venta</mat-label>
            <mat-select [formControl]="salesOfficeMultiCtrl" placeholder="Seleccione las oficinas de venta"
              [multiple]="true" [disabled]="isSalesOfficeDisabled"
              (selectionChange)="onSalesOfficeSelectionChange($event)" required>
              <mat-option>
                <ngx-mat-select-search [showToggleAllCheckbox]="true" [toggleAllCheckboxIndeterminate]="isIndeterminate"
                  [toggleAllCheckboxChecked]="isChecked" (toggleAll)="toggleSelectAll($event)"
                  [formControl]="salesOfficeMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
                  [clearSearchLabel]="'Limpiar búsqueda'"
                  [placeholderLabel]="'Buscar oficina de venta...'"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let sales of filteredSalesOffice | async" [value]="sales">
                <b>{{sales.externalKeys?.code}}</b>-{{ sales.name }}
              </mat-option>
            </mat-select>
            <!-- Mensaje de error si no se ha seleccionado ningún valor -->
            <mat-error *ngIf="
                  salesOfficeMultiCtrl.hasError('required') &&
                  (salesOfficeMultiCtrl.dirty || salesOfficeMultiCtrl.touched)
                ">
              Seleccione oficina de venta
            </mat-error>
          </mat-form-field>
          }

          @if(currentUpdateEmissionPoint.type && currentUpdateEmissionPoint.type == sourceToSetSerialEnum.SUB_ROUTE ){
          <div class="col-span-2">
            <label>Ruta</label>
            <ng-select [(ngModel)]="currentUpdateEmissionPoint.subRouteId" [items]="subRouteListWithCodeName" bindLabel="codeWithName"
              bindValue="_id" [searchable]="true" placeholder="Seleccione una ruta" name="subRouteId"
              (ngModelChange)="onSubRouteSelectionChange($event)" [appendTo]="'body'"
              required>
            </ng-select>
          </div>
          }
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="updateEmissionPoint(currentUpdateEmissionPoint._id)"
          [disabled]="!editForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
  <!-- Filtros -->
  <mat-sidenav #sidenav mode="side" position="end" class="mat-sidenav-content p-0" closed>
    <div class="flex items-center justify-between bg-blue-950 text-white p-4">
      <mat-icon svgIcon="filter_list" class="text-white mr-2 w-4 h-4"></mat-icon>
      <h2 class="text-current text-lg font-bold">Filtros</h2>
      <button mat-icon-button class="ml-auto" (click)="sidenav.close()" matTooltip="Cerrar">
        <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>

    <!-- Compañía -->
    <!-- <div class="mt-6 px-4">
           <div class="w-full mb-4">
             <label for="company-select" class="block text-gray-700">Compañía</label>
             <hr class="m-1">
             <ng-select
               [(ngModel)]="selectedCompanyIds"
               [items]="companyList"
               bindLabel="name"
               bindValue="_id"
               [multiple]="true"
               placeholder="Seleccione Compañía"
               [compareWith]="compareById"
               (ngModelChange)="onCompanySelectionChange($event)"
             >
             </ng-select>
           </div>
         </div> -->

    <div class="flex justify-between mt-4 px-4">
      <button mat-button class="align-left text-gray-700 border border-gray-300" (click)="clearFilters()">
        Limpiar
      </button>
      <button mat-raised-button class="ml-auto bg-blue-950 text-white" (click)="findAllWithCount()">
        Aplicar
      </button>
    </div>
  </mat-sidenav>

  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="handleFilterClean()" (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>
    <app-documents-filters [form]="form" [typeEmissionPoint]="true" [loadData]="loadFiltersData"></app-documents-filters>
    <app-routes-filters [form]="form" [route]="true" [loadData]="loadFiltersData"></app-routes-filters>
  </app-filter>
</mat-sidenav-container>